import { render, staticRenderFns } from "./CustomerNoteListModal.vue?vue&type=template&id=03730089&scoped=true&lang=pug&"
import script from "./CustomerNoteListModal.vue?vue&type=script&lang=js&"
export * from "./CustomerNoteListModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNoteListModal.vue?vue&type=style&index=0&id=03730089&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03730089",
  null
  
)

/* custom blocks */
import block0 from "./CustomerNoteListModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports